import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";

function UpdatePatient(props) {
  const navigate = useHistory();
  const [formData, setName] = useState({
    pName: "",
    caseName: "",
    case_history: "",
  });
  const [Gender, setGender] = useState("");
  const [Patientid, getPatientid] = useState("");
  const UserRole = localStorage.getItem("URole");
  const ManagID = localStorage.getItem("ManegerId");

  const PtId = localStorage.getItem("PatientId");
  const [PortalList, setPortalList] = useState([]);
  const [PoralId, setPortalId] = React.useState("");
  const [selectPortal, setselectPortal] = useState([]);
  // const { IntId, Ques} = get(loadState(), "IntId") || {};
  //console.log("pass id", PtId)
  useEffect(() => {
    LoadPatient();
    LoadPortals();
  }, []);

  const LoadPatient = () => {
    const datavalue = {
      id: PtId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getPatientByid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      setName({
        pName: res.data.result[0].Patient_Nm,
        caseName: res.data.result[0].Case_Name,
        case_history: res.data.result[0].Case_History,
        assessment_blueprint: res.data.result[0].assessment_blueprint,
      });
      setGender(res.data.result[0].P_Gender);
      getPatientid(res.data.result[0].P_id);
      setselectPortal(res.data.result[0].Portal_Id);
      setPortalId(res.data.result[0].Portal_Id);
    });
  };
  const LoadPortals = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetAllPortal`).then((res) => {
      setPortalList(res.data);
    });
  };

  const handleChangePortal = (event) => {
    setPortalId(event.target.value);
    setselectPortal(event.target.value);
  };

  const Patientsubmit = async (e) => {
    e.preventDefault();
    let formDataSet = new FormData();
    //formdata object
    if (
      formData.pName === "" ||
      Gender === "" ||
      PoralId == "" ||
      formData.caseName === ""
    ) {
      if (formData.pName === "") {
        Swal.fire({
          title: "Error",
          text: "Name Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (Gender === "") {
        Swal.fire({
          title: "Error",
          text: "Select Geder",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.caseName === "") {
        Swal.fire({
          title: "Error",
          text: "Case Name Required",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (PoralId === "") {
        Swal.fire({
          title: "Error",
          text: "Please Select Portal",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
    } else {
      formDataSet.append(
        "Patient_Nm",
        formData.pName.charAt(0).toUpperCase() + formData.pName.slice(1)
      ); //append the values with key, value pair
      formDataSet.append(
        "Case_Name",
        formData.caseName == null || formData.caseName == ""
          ? "0"
          : formData.caseName
      );

      formDataSet.append("P_Gender", Gender);
      formDataSet.append("Id", PtId);
      formDataSet.append("P_id", Patientid);
      formDataSet.append("UserId", ManagID);
      formDataSet.append("Portal_Id", PoralId == "" ? selectPortal : PoralId);
      formDataSet.append("case_history", formData.case_history);
      formDataSet.append("assessment_blueprint", formData.assessment_blueprint);

      // const data = {
      //   id: parseInt(PtId),
      //   P_Gender: Gender,
      //   Id: parseInt(PtId),
      //   Case_Name: formData.caseName,
      //   P_id: Patientid,
      //   UserId: ManagID,
      //   Portal_Id: PoralId,
      //   case_history: formData.case_history,
      // };
      // const config = {
      //     headers: { 'content-type': 'multipart/form-data' }
      // }
      // Extract token from localStorage.state
      let token = null;
      try {
        const raw = localStorage.getItem("state");
        if (raw) {
          const state = JSON.parse(raw);
          token = state.auth?.token;
        }
      } catch (e) {
        console.error("Token parsing failed", e);
      }

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/updatePatientByid`,
        data: formDataSet,
        headers: {
          "content-type": "multipart/form-data",
          ...(token && { "Authorization": `Bearer ${token}` })
        },
      };
      axios(authOptions)
        .then((res) => {
          const data = res.data;

          if (data.ExpResult) {
            Swal.fire({
              title: "Error",
              text: data.ExpResult,
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
          else {
            Swal.fire({
              title: "Success",
              text: "Case Update Successfully",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            }).then(function () {
              UserRole === "Admin"
                ? navigate.push("/LCaseList")
                : navigate.push("/LManagerPatientList");
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
        });
    }
  };

  const BackFunc = () => {
    UserRole === "Admin"
      ? navigate.push("/LCaseList")
      : navigate.push("/LManagerPatientList");
  };

  const handleChangeDrp = (event) => {
    setGender(event.target.value);
    //console.log("selected emo", event.target.value)
  };
  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Update Case</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block"
                  style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2 col-sm-2"></div>
            <div className="col-md-8 col-sm-8">
              <div className="card card-box">
                <div className="card-head">
                  <header>Update Case</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={Patientsubmit}
                  >
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Case ID
                      </label>
                      <div className="col-sm-9 pt-3">
                        <span>{Patientid}</span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Portal Id
                      </label>
                      <div className="col-sm-9 pt-3">
                        <span className="mt-2">{selectPortal}</span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Case Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.pName}
                          onChange={handleChange}
                          name="pName"
                          className="form-control"
                          id="simpleFormEmail"
                          placeholder="Enter Case Name"
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Gender
                      </label>
                      <div className="col-md-9">
                        <select
                          className="form-control  select2"
                          value={Gender}
                          onChange={handleChangeDrp}
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.caseName}
                          onChange={handleChange}
                          name="caseName"
                          className="form-control"
                          id="simpleFormEmail"
                          placeholder="Enter Case Description"
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Case History
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          className="form-control"
                          name="case_history"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.case_history}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Assessment Blueprint
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          className="form-control"
                          name="assessment_blueprint"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.assessment_blueprint}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    {UserRole == "Manager" ? (
                      <div></div>
                    ) : (
                      <div className="form-group row">
                        {/* <label for="horizontalFormEmail"
                                                        className="col-sm-2 control-label">Portal</label>
                                                    <div className="col-sm-4">
                                                        <select className="form-control select2" onChange={handleChangePortal} value={selectPortal}>
                                                            <option value="" >--Select--</option>
                                                            {
                                                                PortalList.map((result, i) => {
                                                                    return (
                                                                        <option value={result.id} key={result.id}>{result.portal_Name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div> */}
                      </div>
                    )}
                    <div className="row">
                      <div className="col-12 text-end">
                        <button
                          type="submit"
                          className="btn d-inline-block"
                          style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdatePatient;
